import { render, staticRenderFns } from "./RecepcionTableComponent.vue?vue&type=template&id=40312022&"
import script from "./RecepcionTableComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports